import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../../_actions/loader.actions';
import { postUsersData, verifytoken } from '../../../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../../../components/commonClass/Session';
import { isBlankWithZero, MultiCityobject } from '../../../../../components/commonClass/CommonValidation';
import { encryptUrlDatapattern } from '../../../../../components/commonClass/EncFunc';
import { getAirlineLogo } from '../../../../../components/commonClass/CommonFunctions';
import { getSortedData } from '../../../../../components/commonClass/DataSorting';
import { BoundType, DOMESTIC_RETURN_TYPE_MAP, FlightJourneyType, MoreFareSelectedItem, ReturnDomesticType, SelectedReturnDomestic, SORTING_COLUMN_NAME, SortingOption } from './flight.types';
import MoreFareSlider from './MoreFareSlider';


function convertDurationToHM(duration: any, istotal: any, minutval = false) {
    if (istotal) {
        const layoverTimes: any = [];
        for (let i = 0; i < duration?.length - 1; i++) {
            const arrivalTime: any = new Date(duration[i].arrTime);
            const nextDepartureTime: any = new Date(duration[i + 1].depTime);
            const layoverDuration = nextDepartureTime - arrivalTime;
            if (layoverDuration > 0) {
                const totalMinutes = Math.floor(layoverDuration / (1000 * 60));
                layoverTimes?.push({
                    layover: totalMinutes,
                });
            }
        }
        const totalDuration = duration?.reduce((sum: any, flight: any) => sum + flight?.duration, 0);
        const totallayover = layoverTimes?.reduce((sum: any, flight: any) => sum + flight?.layover, 0);
        const hours = Math?.floor((totalDuration + totallayover) / 60);
        const minutes = (totalDuration + totallayover) % 60;
        if (minutval) {
            return totalDuration + totallayover
        }
        else {
            return `${hours}h ${minutes}m`;
        }
    }
    else {
        const totalDuration = duration?.reduce((sum: any, flight: any) => sum + flight?.duration, 0);
        const hours = Math?.floor((totalDuration) / 60);
        const minutes = totalDuration % 60;
        return `${hours}h ${minutes}m`;
    }
}



const FlightSearchList = ({ flightList, filterFlightList, setFlightList, setFormValue, formValue, setSearchParams, searchParams, calendarfare, traceId, JourneyType, datalist }: any) => {
    const stored = sessionStorage.getItem('isinternational');
    const isInternational: boolean = stored ? JSON.parse(stored) : false;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [buttonradio, setButtonRadio] = useState('Outbound')
    const [tabDomestic, setTabDomestic] = useState<{
        from: SortingOption;
        return: SortingOption;
    }>({
        from: 'Best',
        return: 'Best'
    })
    const [selectedRetunDomestic, setSelectedRetunDomestic] = useState<SelectedReturnDomestic>({
        OutBound: null,
        InBound: null
    })
    const [moreFareid, setMoreFareId] = useState<string[]>([])
    const [moreFareSelected, setMoreFareSelected] = useState<MoreFareSelectedItem[]>([])

    useEffect(() => {
        setMoreFareId([]);
        setMoreFareSelected([]);
    }, [filterFlightList])

    const handleClickSlide = async (selectedData: any) => {
        const userData: any = GetLocalStorage();
        if (userData) {
            const queryObject: any = Object?.fromEntries(searchParams?.entries());
            const MultiCityobj: any = MultiCityobject(Object?.fromEntries(searchParams?.entries()))

            const urlParams = new URLSearchParams(searchParams);
            urlParams.set('tId', encryptUrlDatapattern(traceId));
            urlParams.set('rIndex', encryptUrlDatapattern(selectedData?.map((el: any) => el?.newFare?.resultIndex)));

            const commonPayload = {
                flightBookingId: 0,
                returnDate: selectedData?.length === 1 ? queryObject?.ReturnDate ? queryObject?.ReturnDate : null : null,
                bookingId: 0,
                pnr: "",
                JourneyTypeId: JourneyType,
                airlineCode: "",
                ticketStatus: 0,
                userId: userData?.userMasterID || 0
            }

            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                const bookingIdsPromise = await Promise.allSettled(
                    (selectedData || [])?.map(async (fligth: any, index: any) => {

                        const travellerBookingData = {
                            ...commonPayload,
                            departureDate: queryObject?.tripType === "Multi Stop" ? MultiCityobj?.map((el: any) => el?.Departure) : index === 0 ? [queryObject?.DepartureDate ? queryObject?.DepartureDate : null] : [queryObject?.ReturnDate ? queryObject?.ReturnDate : null],
                            isLCC: fligth?.isLCC || false,
                            origin: queryObject?.tripType === "Multi Stop" ? MultiCityobj?.map((el: any) => el?.FromCityCode) : (index === 0 ? [queryObject?.fcc] : [queryObject?.tcc]),
                            destination: queryObject?.tripType === "Multi Stop" ? MultiCityobj?.map((el: any) => el?.ToCityCode) : (index === 0 ? [queryObject?.tcc] : [queryObject?.fcc]),
                            adults: fligth?.newFare?.fareBreakdown?.find((fin: any) => fin?.passengerType === 1)?.passengerCount || 0,
                            children: fligth?.newFare?.fareBreakdown?.find((fin: any) => fin?.passengerType === 2)?.passengerCount || 0,
                            infant: fligth?.newFare?.fareBreakdown?.find((fin: any) => fin?.passengerType === 3)?.passengerCount || 0,
                            baseFare: fligth?.newFare?.fare?.baseFare || 0,
                            tax: fligth?.newFare?.fare?.totalTaxAndSurcharges || 0,
                            finalValue: fligth?.newFare?.fare?.grandTotal || 0,
                            CabinClass: fligth?.segments?.[0]?.[0]?.cabinClass || 0,
                            Markup: fligth?.newFare?.fare?.markupCharges,
                            GSTAmount: fligth?.newFare?.fare?.gstCharges,
                        }

                        const insertflighttravellerbooking = await postUsersData('/customerui/v1/insertflighttravellerbooking', travellerBookingData)
                        if (insertflighttravellerbooking?.status) {
                            return insertflighttravellerbooking?.data;
                        }
                        return null;
                    })
                )

                const bookingIds = bookingIdsPromise?.map(({ value }: any) => value)?.filter(Boolean);
                const isBookingIdBlank = bookingIds?.filter((item) => isBlankWithZero?.includes(item))?.length > 0;

                if (isBookingIdBlank) {
                    dispatch(loaderActions.end());
                    dispatch({ type: 'ALERTING', message: "Something went wrong, Please try again!", redirectTo: '/' });
                    return;
                }

                dispatch(loaderActions.end());
                sessionStorage.setItem('isDomRtn', '0');
                navigate(`/flight/review?${urlParams?.toString()}`, { state: { BookingId: encryptUrlDatapattern(bookingIds) } });
            }
            else {
                dispatch(loaderActions.end());
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
                return;
            }

        }
        else {
            dispatch({ type: "SHOW_OR_HIDE_LOGIN_MODEL", payload: true });
        }
    }

    const createSearchUrl = (data: any) => {
        const urlParams: any = new URLSearchParams(searchParams);
        Object.entries(data).forEach((val: any) => {
            // let keys = ["IsCheapest", "IsFastest"];
            // if (keys.includes(val[0])) {
            //     urlParams.set(val[0], val[1]);
            // }
            if (val[0] === "Segments") {
                urlParams.set("DepartureDate", formatDatemain(val[1]?.[0]?.PreferredDepartureTime));
            }
        })
        urlParams.set('isExplore', true)
        setSearchParams(urlParams)
    }

    const hendleTab = (name: any) => {
        let filterData = { ...formValue }
        if (name === 'Best') {
            filterData = { ...filterData, IsCheapest: false, IsFastest: false, }
        }
        else if (name === 'Cheapest') {
            filterData = { ...filterData, IsCheapest: true, IsFastest: false, }
        }
        else if (name === 'Fastest') {
            filterData = { ...filterData, IsFastest: true, IsCheapest: false, }
        }
        setFormValue(filterData);
        // createSearchUrl(filterData)
    }

    const hendleTabdomestic = (type: any, val: any) => {
        setTabDomestic(prev => ({
            ...prev,
            [type]: val
        }));
    }

    //#region domestic return flight data list
    const domesticFlightList = useMemo(() => {
        if (flightList) {
            const outboundList = flightList?.filter((flight: any) => {
                return flight?.segments?.[0]?.some((segment: any) =>
                    segment?.origin?.airport?.cityCode === searchParams?.get("fcc")
                )
            })
            const inboundList = flightList?.filter((flight: any) => {
                return flight?.segments?.[flight?.segments?.length - 1]?.some((segment: any) =>
                    segment?.origin?.airport?.cityCode === searchParams?.get("tcc")
                )
            })

            const fromval = tabDomestic?.from === "Best" ? outboundList : getSortedData(outboundList, true, SORTING_COLUMN_NAME?.[tabDomestic?.from], "number");
            const toval = tabDomestic?.return === "Best" ? inboundList : getSortedData(inboundList, true, SORTING_COLUMN_NAME?.[tabDomestic?.return], "number");

            return {
                from: fromval,
                to: toval
            }
        }
        return null;
    }, [flightList, tabDomestic, searchParams])
    //#endregion

    useEffect(() => {
        if (domesticFlightList) {
            setSelectedRetunDomestic((prev) => ({
                ...prev,
                OutBound: domesticFlightList?.from?.[0] || prev?.OutBound || null,
                InBound: domesticFlightList?.to?.[0] || prev?.InBound || null
            }))
        } else {
            setSelectedRetunDomestic((prev) => ({ ...prev, OutBound: null, InBound: null }))
        }
    }, [domesticFlightList])

    //#region display data not found message 
    const { dataStatus, noDataMessage } = useMemo(() => {
        const isFlightListBlank = JourneyType === 2 && !isInternational ? domesticFlightList?.from?.length <= 0 || domesticFlightList?.to?.length <= 0 : flightList?.length <= 0;
        const params = Object.fromEntries(searchParams.entries());

        if (flightList === null) return { dataStatus: "none", noDataMessage: "" };

        if (params?.isExplore === "true") return { dataStatus: "none", noDataMessage: "" };

        if (flightList?.length === 0 && filterFlightList?.length === 0)
            return { dataStatus: "noRecords", noDataMessage: "No Records Found" };

        if (filterFlightList?.length > 0 && isFlightListBlank)
            return { dataStatus: "tooManyFilters", noDataMessage: "Too many filter selected. Please refine your search" };

        return { dataStatus: "none", noDataMessage: "" };

    }, [JourneyType, isInternational, domesticFlightList?.from?.length, domesticFlightList?.to?.length, flightList, searchParams, filterFlightList?.length]);
    //#endregion

    const flightdatechnage = (val: any) => {
        let filterData = { ...formValue }
        filterData = {
            ...filterData, Segments: filterData?.Segments?.map((segment: any, index: any) =>
                index === 0 ? {
                    ...segment, PreferredDepartureTime: val + "T00:00:00"
                } : segment
            )
        }
        setFormValue(filterData);
        createSearchUrl(filterData)
    }

    function formatTo12Hour(dateString: any) {
        const date = new Date(dateString);
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12;
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;

        return `${hours}:${formattedMinutes} ${ampm}`;
    }


    function formatDate(dateString: any, type: any) {
        const date = new Date(dateString);
        if (type === "DDDMMMD") {
            return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
        }
        else if (type === "DDDMMMDYY") {
            return date.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: '2-digit' });
        }
        else {
            return date.toLocaleDateString('en-US', { weekday: 'short', day: 'numeric', month: 'short' });
        }
    }

    function formatDatemain(date: any) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return date === null ? null : [year, month, day].join('-');
    }

    const Flightoverlap = useMemo(() => {
        if (domesticFlightList && selectedRetunDomestic?.OutBound !== null && selectedRetunDomestic?.InBound !== null) {
            let fromobj = selectedRetunDomestic?.OutBound?.segments?.[0]
            let toobj = selectedRetunDomestic?.InBound?.segments?.[0]

            const startTime: any = new Date(fromobj?.[fromobj?.length - 1]?.destination?.arrTime);
            const endTime: any = new Date(toobj?.[0]?.origin?.depTime);
            const diffMs = endTime - startTime;
            const fiveHoursInMs = 5 * 60 * 60 * 1000;
            return diffMs < fiveHoursInMs;
        }
    }, [selectedRetunDomestic, domesticFlightList])

    const openslider = (flightIndex: number, data: any, overlap: any, flightJourneyType: FlightJourneyType) => {
        if (overlap) {
            if (!Flightoverlap) {
                handleClickSlide(data)
            }
        }
        else {
            const flightsWithSelectedFare = applySelectedFareToFlights(flightIndex, data, flightJourneyType, false);
            handleClickSlide(flightsWithSelectedFare)
        }
    }

    const getactiveindex = () => {
        let idx = 0
        Object?.values(calendarfare)?.forEach((el: any, index: any) => {
            if (formatDatemain(searchParams.get("DepartureDate")) === formatDatemain(el?.departureDate)) {
                idx = index - 3
            }
        })
        return idx
    }

    //#region handle select return domestic flights function
    const handleSelectReturnDomesticFlight = (e: any, mainIndex: number, returnDoemsticType: ReturnDomesticType, selectedFlight: any) => {
        e.stopPropagation();
        if (selectedRetunDomestic?.[DOMESTIC_RETURN_TYPE_MAP?.[returnDoemsticType]]?.resultIndex !== selectedFlight?.resultIndex) {
            setSelectedRetunDomestic((prev) => ({ ...prev, [DOMESTIC_RETURN_TYPE_MAP?.[returnDoemsticType]]: applySelectedFareToFlights(mainIndex, selectedFlight, returnDoemsticType, true) }));
        }
    }
    //#endregion

    //#region hendle more function
    const hendlemore = (e: any, id: string) => {
        e.stopPropagation();
        setMoreFareId((prev) => {
            const next = new Set<string>(prev);
            next?.has(id) ? next?.delete(id) : next?.add(id);
            return Array.from(next);
        });
    }
    //#endregion

    //#region handle get more fare details function
    const getMoreFareDetails = (flightJourneyType: FlightJourneyType, key: keyof MoreFareSelectedItem) => {
        return moreFareSelected?.filter((item) => item?.flightJourneyType === flightJourneyType)?.map((ele) => ele?.[key]);
    }
    //#endregion

    //#region hendle select more fare function
    const hendleSelectMoreFare = (e: any, id: string, index: number, moreFare: any, flightJourneyType: FlightJourneyType, isReturnDomestic: boolean = false, parentFlight: any = null) => {
        e.stopPropagation();
        const isFlightIndex = getMoreFareDetails(flightJourneyType, "index");
        const isResultIndex = getMoreFareDetails(flightJourneyType, "id");

        if (!isResultIndex?.includes(id)) {
            if (isFlightIndex?.includes(index)) {
                setMoreFareSelected((prev) => (
                    prev?.map((obj) => obj?.flightJourneyType === flightJourneyType && obj?.index === index ? { ...obj, id, moreFare } : obj)
                ));
            }
            else {
                setMoreFareSelected((prev) => ([
                    ...prev,
                    { id, index, moreFare, flightJourneyType }
                ]));
            }
        }

        // Update selectedRetunDomestic with selected moreFare for domestic return flights
        if (isReturnDomestic && parentFlight) {
            const domKey = DOMESTIC_RETURN_TYPE_MAP[flightJourneyType as ReturnDomesticType];
            if (domKey) {
                setSelectedRetunDomestic((prev) => ({
                    ...prev,
                    [domKey]: { ...parentFlight, newFare: moreFare }
                }));
            }
        }
    }
    //#endregion

    //#region return domestic flight active class function
    const returnDoemsticFlightActiveClass = (flight: any, key: BoundType) => {
        return flight?.fareOptions ?
            flight?.fareOptions?.find((item: any) => item?.resultIndex === selectedRetunDomestic?.[key]?.newFare?.resultIndex)
            :
            flight?.resultIndex === selectedRetunDomestic?.[key]?.newFare?.resultIndex
    }
    //#endregion

    //#region get fare active class function
    const getFareActiveClass = (mainIndex: number, resultIndex: string = "", moreFareIndex: number = 0, flightJourneyType: FlightJourneyType) => {
        const selectedForType = moreFareSelected?.find(
            item => item?.flightJourneyType === flightJourneyType && item?.index === mainIndex + 1
        );
        if (!selectedForType) return moreFareIndex === 0 ? 'active' : '';
        return selectedForType?.id === resultIndex ? 'active' : '';
    }
    //#endregion

    //#region get fare price function
    const getFarePrice = (mainIndex: number, flight: any, flightJourneyType: FlightJourneyType) => {
        return getMoreFareDetails(flightJourneyType, "index")?.includes(mainIndex + 1) ?
            moreFareSelected
                ?.find(find => find?.index === mainIndex + 1 && find?.flightJourneyType === flightJourneyType)?.moreFare?.fareBreakdown
                ?.find((find: any) => find?.passengerType === 1)?.pricePerPerson
            :
            flight?.fareBreakdown?.find((find: any) => find?.passengerType === 1)?.pricePerPerson
    }
    //#endregion

    //#region apply selected fare to flights function
    const applySelectedFareToFlights = (mainIndex: number, data: any, flightJourneyType: FlightJourneyType, isReturnDomestic: boolean = false) => {
        const isSelected = getMoreFareDetails(flightJourneyType, "index")?.includes(mainIndex + 1);
        if (isReturnDomestic) {
            const newFare = isSelected ?
                moreFareSelected?.find(find => find?.index === mainIndex + 1 && find?.flightJourneyType === flightJourneyType)?.moreFare
                : data?.newFare
            return { ...data, newFare }
        }
        else {
            return data?.map((ele: any) => ({
                ...ele,
                newFare: isSelected ?
                    moreFareSelected?.find(find => find?.index === mainIndex + 1 && find?.flightJourneyType === flightJourneyType)?.moreFare
                    : ele?.newFare
            }))
        }
    }
    //#endregion

    return (
        <div className={`detailContainer ${(JourneyType === 2 && !isInternational) ? 'returnFlight' : ''}`}>
            {(!['2', '3']?.includes(JourneyType)) && Object?.values(calendarfare)?.length > 0 && <Splide
                hasTrack={false}
                className='chooseFlyDate'
                id="chooseFlyDateSlider"
                options={{
                    start: getactiveindex(),
                    perPage: 7,
                    perMove: 0,
                    gap: 0,
                    type: "slide",
                    drag: "free",
                    snap: false,
                    interval: 2000,
                    arrows: true,
                    pagination: false,
                    autoplay: false,
                    breakpoints: {
                        1599: {
                            perPage: 5,
                            snap: true
                        },
                        1199: {
                            perPage: 4,
                            snap: true
                        },
                        768: {
                            perPage: 3,
                            snap: true
                        },
                        575: {
                            perPage: 3,
                            snap: true
                        },
                        480: {
                            perPage: 2,
                            snap: true
                        }
                    }
                }}
                aria-label="My Favorite Images"
            >
                <div className="calendar cursor_pointer">
                    <span className="icon">
                        <i className="fa-regular fa-calendar-days"></i>
                    </span>
                </div>
                <SplideTrack>
                    {Object?.values(calendarfare)?.map((el: any, index: any) => (
                        <SplideSlide
                            onClick={() => flightdatechnage(formatDatemain(el?.departureDate))}
                            className={`${formatDatemain(searchParams.get("DepartureDate")) === formatDatemain(el?.departureDate) ? 'active' : ''}`}
                            key={index}
                        >
                            <div className="dateprice cursor_pointer">
                                <p>{formatDate(el?.departureDate, "DDDMMMD")}</p>
                                <p><span className="price">₹ {el?.fare}</span></p>
                            </div>
                        </SplideSlide>
                    ))}
                </SplideTrack>
            </Splide>}
            {(JourneyType === 3 && flightList?.length > 0) && <div className="destinationScroll">
                <ul className="destinationList">
                    {flightList?.length > 0 && formValue?.Segments?.map((flight: any, index: any) => (
                        <li className="list" key={index}>
                            <h4>{datalist?.cityList?.find((el: any) => el.CityCode === flight?.Origin)?.City}&nbsp;<i className="fa-solid fa-plane"></i>&nbsp;{datalist?.cityList?.find((el: any) => el.CityCode === flight?.Destination)?.City}</h4>
                            <p>{formatDate(flight?.PreferredDepartureTime, "DDDMMMDYY")}</p>
                        </li>
                    ))}
                </ul>
            </div>}
            {(!(JourneyType === 2 && !isInternational) && flightList?.length > 0) && <div className="flightShorting">
                <ul>
                    <li onClick={(e) => hendleTab('Best')} className={`cursor_pointer ${(!formValue?.IsCheapest && !formValue?.IsFastest) ? 'active' : ''}`}>Best
                        <p>
                            {/* <span>$364</span> · 17h 45m */}
                        </p>
                    </li>
                    <li onClick={(e) => hendleTab('Cheapest')} className={`cursor_pointer ${formValue?.IsCheapest ? 'active' : ''}`}>Cheapest
                        <p>
                            {/* <span>₹{flightList?.[0]?.fare?.grandTotal }</span> · 28h 15m */}
                        </p>
                    </li>
                    <li onClick={(e) => hendleTab('Fastest')} className={`cursor_pointer ${formValue?.IsFastest ? 'active' : ''}`}>Fastest
                        <p>
                            {/* <span>$602</span> · 10h 20m */}
                        </p>
                    </li>
                </ul>
            </div>}
            {(JourneyType === 2 && !isInternational && domesticFlightList?.from?.length > 0 && domesticFlightList?.to?.length > 0) &&
                <>
                    <div className="multiCityPrice-container">
                        <div className="multicityScroll">
                            <div className="multicityDiv">
                                <div className="flightbox px-2">
                                    {selectedRetunDomestic?.OutBound?.segments?.map((el: any, index: any) => (
                                        <div className="flyDetails d-flex align-items-center">
                                            <div className="placeTime col-3">
                                                <span>{el?.[0]?.origin?.airport?.cityCode}</span>
                                                <p>{formatTo12Hour(el?.[0]?.origin?.depTime)}</p>
                                            </div>
                                            <div className="duration col-6 text-center">
                                                <div>
                                                    <span className="stop me-1">{el?.length > 1 ? el?.length - 1 + ' Stop' : "Direct"}</span>
                                                </div>
                                                {el?.map((ele: any, childindex: any) => (
                                                    <img key={childindex} src={getAirlineLogo(ele?.airline?.airlineCode)}
                                                        onError={(e: any) => e.target.src = require("../../../../../assets/img/no-image.png")}
                                                        loading="lazy"
                                                        height="25px" width="25px"
                                                        className='rounded me-1'
                                                        title={ele?.airline?.airlineName}
                                                        alt="flights logo" />
                                                ))}
                                                <p className='mb-0 mt-1'>{convertDurationToHM(el?.map((ele: any) => ({
                                                    duration: ele?.duration,
                                                    depTime: ele?.origin?.depTime,
                                                    arrTime: ele?.destination?.arrTime
                                                })), true)}</p>
                                            </div>
                                            <div className="placeTime col-3">
                                                <span>{el?.[el?.length - 1]?.destination?.airport?.cityCode}</span>
                                                <p>{formatTo12Hour(el?.[el?.length - 1]?.destination?.arrTime)}</p>
                                            </div>
                                        </div>
                                    )
                                    )}
                                </div>
                                <div className="flightbox px-2">
                                    {selectedRetunDomestic?.InBound?.segments?.map((el: any, index: any) => (
                                        <div className="flyDetails d-flex align-items-center">
                                            <div className="placeTime col-3">
                                                <span>{el?.[0]?.origin?.airport?.cityCode}</span>
                                                <p>{formatTo12Hour(el?.[0]?.origin?.depTime)}</p>
                                            </div>
                                            <div className="duration col-6 text-center">
                                                <div>
                                                    <span className="stop me-1">{el?.length > 1 ? el?.length - 1 + ' Stop' : "Direct"}</span>
                                                </div>
                                                {el?.map((ele: any, childindex: any) => (
                                                    <img key={childindex} src={getAirlineLogo(ele?.airline?.airlineCode)}
                                                        onError={(e: any) => e.target.src = require("../../../../../assets/img/no-image.png")}
                                                        loading="lazy"
                                                        height="25px" width="25px"
                                                        className='rounded me-1 posotion-relative'
                                                        title={ele?.airline?.airlineName}
                                                        alt="flights logo" />
                                                ))}
                                                <p className='mb-0 mt-1'>{convertDurationToHM(el?.map((ele: any) => ({
                                                    duration: ele?.duration,
                                                    depTime: ele?.origin?.depTime,
                                                    arrTime: ele?.destination?.arrTime
                                                })), true)}</p>
                                            </div>
                                            <div className="placeTime col-3">
                                                <span>{el?.[el?.length - 1]?.destination?.airport?.cityCode}</span>
                                                <p>{formatTo12Hour(el?.[el?.length - 1]?.destination?.arrTime)}</p>
                                            </div>
                                        </div>
                                    )
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="totalFare">
                            <div>
                                <p>Total Fare:</p>
                                <h4>
                                    {(selectedRetunDomestic?.OutBound?.newFare?.fareBreakdown?.find((find: any) => find?.passengerType === 1)?.pricePerPerson || 0)
                                        + (selectedRetunDomestic?.InBound?.newFare?.fareBreakdown?.find((find: any) => find?.passengerType === 1)?.pricePerPerson || 0)}
                                </h4>
                            </div>
                            <button type="button" disabled={Flightoverlap} onClick={() => openslider(-2, [selectedRetunDomestic?.OutBound, selectedRetunDomestic?.InBound], true, "ReturnDomesticBoth")} className="btn booknow select position-relative">Book Now</button>
                            {Flightoverlap && <span className='overlap_message'>The flight combination you have selected have overlapping timings.</span>}
                        </div>
                    </div>
                    <div className="return-mobile-button">
                        <label> <input type="radio" name="content" onClick={() => setButtonRadio("Outbound")} checked={buttonradio === "Outbound" ? true : false} /><span>Outbound Flights</span></label>
                        <label> <input type="radio" name="content" onClick={() => setButtonRadio("Inbound")} checked={buttonradio === "Inbound" ? true : false} /><span>Inbound Flights</span></label>
                    </div>
                </>
            }
            {(JourneyType < 3 && (JourneyType === 2 ? isInternational : true)) &&
                flightList?.map((flight: any, mainindex: any) => (
                    <div className="row flightdetail" key={mainindex}>
                        <div className="col-lg-9 col-md-8 col-sm-8 detail">
                            {flight?.segments?.map((el: any, index: any) => {
                                if (index === 0) {
                                    return (
                                        <Fragment>
                                            <h4 className="bound">Outbound</h4>
                                            <div className="flyDetails">
                                                <div className="placeTime">
                                                    <span>{el?.[0]?.origin?.airport?.cityCode}</span>
                                                    <p>{formatTo12Hour(el?.[0]?.origin?.depTime)}</p>
                                                </div>
                                                <div className="duration">
                                                    <span className="stop me-1">{el?.length > 1 ? el?.length - 1 + ' Stop' : "Direct"}</span>
                                                    {el?.map((ele: any, childindex: any) => (
                                                        <img key={childindex} src={getAirlineLogo(ele?.airline?.airlineCode)}
                                                            onError={(e: any) => e.target.src = require("../../../../../assets/img/no-image.png")}
                                                            loading="lazy"
                                                            height="25px" width="25px"
                                                            className='rounded me-1'
                                                            title={ele?.airline?.airlineName}
                                                            alt="flights logo" />
                                                    ))}
                                                    <p>{convertDurationToHM(el?.map((ele: any) => ({
                                                        duration: ele?.duration,
                                                        depTime: ele?.origin?.depTime,
                                                        arrTime: ele?.destination?.arrTime
                                                    })), true)}</p>
                                                </div>
                                                <div className="placeTime">
                                                    <span>{el?.[el?.length - 1]?.destination?.airport?.cityCode}</span>
                                                    <p>{formatTo12Hour(el?.[el?.length - 1]?.destination?.arrTime)}</p>
                                                </div>
                                            </div>
                                        </Fragment>
                                    )
                                }
                                if (index === 1) {
                                    return (
                                        <Fragment>
                                            <h4 className="bound">Inbound</h4>
                                            <div className="flyDetails">
                                                <div className="placeTime">
                                                    <span>{el?.[0]?.origin?.airport?.cityCode}</span>
                                                    <p>{formatTo12Hour(el?.[0]?.origin?.depTime)}</p>
                                                </div>
                                                <div className="duration">
                                                    <span className="stop me-1">{el?.length > 1 ? el?.length - 1 + ' Stop' : "Direct"}</span>
                                                    {el?.map((ele: any, childindex: any) => (
                                                        <img key={childindex} src={getAirlineLogo(ele?.airline?.airlineCode)}
                                                            onError={(e: any) => e.target.src = require("../../../../../assets/img/no-image.png")}
                                                            loading="lazy"
                                                            height="25px" width="25px"
                                                            className='rounded me-1'
                                                            title={ele?.airline?.airlineName}
                                                            alt="flights logo" />
                                                    ))}
                                                    <p>{convertDurationToHM(el?.map((ele: any) => ({
                                                        duration: ele?.duration,
                                                        depTime: ele?.origin?.depTime,
                                                        arrTime: ele?.destination?.arrTime
                                                    })), true)}</p>
                                                </div>
                                                <div className="placeTime">
                                                    <span>{el?.[el?.length - 1]?.destination?.airport?.cityCode}</span>
                                                    <p>{formatTo12Hour(el?.[el?.length - 1]?.destination?.arrTime)}</p>
                                                </div>
                                            </div>
                                        </Fragment>
                                    )
                                }
                            })}
                            {
                                flight?.fareOptions?.length > 0 &&
                                <button className="toggle-btn" onClick={(e) => hendlemore(e, flight?.resultIndex)}>More Fare <i className='fa fa-angle-down'></i></button>
                            }
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-4">
                            <div className="priceBox">
                                <div className="price"><span>₹ {getFarePrice(mainindex, flight, JourneyType === 1 ? "OneWayBoth" : "ReturnInternational")}</span> Per Person</div>
                                {/* <div className="price"><span>₹ {flight?.fareBreakdown?.find((find: any) => find?.passengerType === 1)?.pricePerPerson}</span> Per Person</div> */}
                                {/* <button type="button" className="btn lockprice"> Lock price for <span>₹ 1500</span> </button> */}
                                <button type="button" className="btn select" onClick={(e) => openslider(mainindex, [flight], false, JourneyType === 1 ? "OneWayBoth" : "ReturnInternational")}>Select</button>
                            </div>
                        </div>

                        <MoreFareSlider
                            mainIndex={mainindex}
                            moreFareid={moreFareid}
                            flight={flight}
                            splideClassName="onewayFlight morefare"
                            splideId={`onewayFlightSlider${mainindex + 1}`}
                            ariaLabel={`One Way Flight Slider ${mainindex + 1}`}
                            flightJourneyType={JourneyType === 1 ? "OneWayBoth" : "ReturnInternational"}
                            getFareActiveClass={getFareActiveClass}
                            hendleSelectMoreFare={hendleSelectMoreFare}
                        />

                    </div>
                ))}
            {(JourneyType === 2 && !isInternational && domesticFlightList?.from?.length > 0 && domesticFlightList?.to?.length > 0) &&
                <>
                    <div id="outboundBox" className={`outboundBox ${buttonradio === "Outbound" ? 'active' : ''}`}>
                        <div className="flightShorting">
                            <ul>
                                <li onClick={(e) => hendleTabdomestic('from', 'Best')} className={`cursor_pointer ${tabDomestic?.from === 'Best' ? 'active' : ''}`}>Best
                                    <p>
                                        {/* <span>$364</span> · 17h 45m */}
                                    </p>
                                </li>
                                <li onClick={(e) => hendleTabdomestic('from', 'Cheapest')} className={`cursor_pointer ${tabDomestic?.from === 'Cheapest' ? 'active' : ''}`}>Cheapest
                                    <p>
                                        {/* <span>₹{flightList?.[0]?.fare?.grandTotal }</span> · 28h 15m */}
                                    </p>
                                </li>
                                <li onClick={(e) => hendleTabdomestic('from', 'Fastest')} className={`cursor_pointer ${tabDomestic?.from === 'Fastest' ? 'active' : ''}`}>Fastest
                                    <p>
                                        {/* <span>$602</span> · 10h 20m */}
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div className='outbondList'>
                            {domesticFlightList?.from?.map((flight: any, mainindex: any) => (
                                flight?.segments?.map((el: any, index: any) => (
                                    <div onClick={(e: any) => handleSelectReturnDomesticFlight(e, mainindex, "ReturnDomesticOutBound", flight)} className={`row flightdetail ${returnDoemsticFlightActiveClass(flight, "OutBound") ? 'active' : ''}`} key={mainindex}>
                                        <div className="col-lg-9 col-md-8 col-sm-8 detail">
                                            <h4 className="bound">Outbound</h4>
                                            <div className="flyDetails">
                                                <div className="placeTime">
                                                    <span>{el?.[0]?.origin?.airport?.cityCode}</span>
                                                    <p>{formatTo12Hour(el?.[0]?.origin?.depTime)}</p>
                                                </div>
                                                <div className="duration">
                                                    <span className="stop me-1">{el?.length > 1 ? el?.length - 1 + ' Stop' : "Direct"}</span>
                                                    {el?.map((ele: any, childindex: any) => (
                                                        <img key={childindex} src={getAirlineLogo(ele?.airline?.airlineCode)}
                                                            onError={(e: any) => e.target.src = require("../../../../../assets/img/no-image.png")}
                                                            loading="lazy"
                                                            height="25px" width="25px"
                                                            className='rounded me-1'
                                                            title={ele?.airline?.airlineName}
                                                            alt="flights logo" />
                                                    ))}
                                                    <p>{convertDurationToHM(el?.map((ele: any) => ({
                                                        duration: ele?.duration,
                                                        depTime: ele?.origin?.depTime,
                                                        arrTime: ele?.destination?.arrTime
                                                    })), true)}</p>
                                                </div>
                                                <div className="placeTime">
                                                    <span>{el?.[el?.length - 1]?.destination?.airport?.cityCode}</span>
                                                    <p>{formatTo12Hour(el?.[el?.length - 1]?.destination?.arrTime)}</p>
                                                </div>
                                            </div>
                                            {
                                                flight?.fareOptions?.length > 0 &&
                                                <button className="toggle-btn" onClick={(e) => hendlemore(e, flight?.resultIndex)}>More Fare <i className='fa fa-angle-down'></i></button>
                                            }
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-4">
                                            <div className="priceBox">
                                                <div className="price"><span>₹ {getFarePrice(mainindex, flight, "ReturnDomesticOutBound")}</span> Per Person</div>
                                                {/* <div className="price"><span>₹ {flight?.fareBreakdown?.find((find: any) => find?.passengerType === 1)?.pricePerPerson}</span> Per Person</div> */}
                                            </div>
                                        </div>

                                        <MoreFareSlider
                                            mainIndex={mainindex}
                                            moreFareid={moreFareid}
                                            flight={flight}
                                            splideClassName='domesticReturn morefare'
                                            splideId={`domesticReturnOutBoundSlider${mainindex + 1}`}
                                            ariaLabel={`Domestic Return OutBound Slider ${mainindex + 1}`}
                                            flightJourneyType="ReturnDomesticOutBound"
                                            getFareActiveClass={getFareActiveClass}
                                            hendleSelectMoreFare={hendleSelectMoreFare}
                                        />
                                    </div>
                                )
                                )
                            ))}
                        </div>
                    </div>
                    <div id="inboundBox" className={`inboundBox ${buttonradio === "Inbound" ? 'active' : ''}`}>
                        <div className="flightShorting">
                            <ul>
                                <li onClick={(e) => hendleTabdomestic('return', 'Best')} className={`cursor_pointer ${tabDomestic?.return === 'Best' ? 'active' : ''}`}>Best
                                    <p>
                                        {/* <span>$364</span> · 17h 45m */}
                                    </p>
                                </li>
                                <li onClick={(e) => hendleTabdomestic('return', 'Cheapest')} className={`cursor_pointer ${(tabDomestic?.return === 'Cheapest') ? 'active' : ''}`}>Cheapest
                                    <p>
                                        {/* <span>₹{flightList?.[0]?.fare?.grandTotal }</span> · 28h 15m */}
                                    </p>
                                </li>
                                <li onClick={(e) => hendleTabdomestic('return', 'Fastest')} className={`cursor_pointer ${tabDomestic?.return === 'Fastest' ? 'active' : ''}`}>Fastest
                                    <p>
                                        {/* <span>$602</span> · 10h 20m */}
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div className='inbondList'>
                            {domesticFlightList?.to?.map((flight: any, mainindex: any) => (
                                flight?.segments?.map((el: any, index: any) => (
                                    <div onClick={(e) => handleSelectReturnDomesticFlight(e, mainindex, "ReturnDomesticInBound", flight)} className={`row flightdetail ${returnDoemsticFlightActiveClass(flight, "InBound") ? 'active' : ''}`} key={mainindex}>
                                        <div className="col-lg-9 col-md-8 col-sm-8 detail">
                                            <h4 className="bound">Inbound</h4>
                                            <div className="flyDetails">
                                                <div className="placeTime">
                                                    <span>{el?.[0]?.origin?.airport?.cityCode}</span>
                                                    <p>{formatTo12Hour(el?.[0]?.origin?.depTime)}</p>
                                                </div>
                                                <div className="duration">
                                                    <span className="stop me-1">{el?.length > 1 ? el?.length - 1 + ' Stop' : "Direct"}</span>
                                                    {el?.map((ele: any, childindex: any) => (
                                                        <img key={childindex} src={getAirlineLogo(ele?.airline?.airlineCode)}
                                                            onError={(e: any) => e.target.src = require("../../../../../assets/img/no-image.png")}
                                                            loading="lazy"
                                                            height="25px" width="25px"
                                                            className='rounded me-1'
                                                            title={ele?.airline?.airlineName}
                                                            alt="flights logo" />
                                                    ))}
                                                    <p>{convertDurationToHM(el?.map((ele: any) => ({
                                                        duration: ele?.duration,
                                                        depTime: ele?.origin?.depTime,
                                                        arrTime: ele?.destination?.arrTime
                                                    })), true)}</p>
                                                </div>
                                                <div className="placeTime">
                                                    <span>{el?.[el?.length - 1]?.destination?.airport?.cityCode}</span>
                                                    <p>{formatTo12Hour(el?.[el?.length - 1]?.destination?.arrTime)}</p>
                                                </div>
                                            </div>
                                            {
                                                flight?.fareOptions?.length > 0 &&
                                                <button className="toggle-btn" onClick={(e) => hendlemore(e, flight?.resultIndex)}>More Fare <i className='fa fa-angle-down'></i></button>
                                            }
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-4">
                                            <div className="priceBox">
                                                {/* <div className="price"><span>₹ {flight?.fareBreakdown?.find((find: any) => find?.passengerType === 1)?.pricePerPerson}</span> Per Person</div> */}
                                                <div className="price"><span>₹ {getFarePrice(mainindex, flight, "ReturnDomesticInBound")}</span> Per Person</div>
                                            </div>
                                        </div>

                                        <MoreFareSlider
                                            mainIndex={mainindex}
                                            moreFareid={moreFareid}
                                            flight={flight}
                                            splideClassName='domesticReturn morefare'
                                            splideId={`domesticReturnInBoundSlider${mainindex + 1}`}
                                            ariaLabel={`Domestic Return InBound Slider ${mainindex + 1}`}
                                            flightJourneyType="ReturnDomesticInBound"
                                            getFareActiveClass={getFareActiveClass}
                                            hendleSelectMoreFare={hendleSelectMoreFare}
                                        />

                                    </div>
                                )
                                )
                            ))}
                        </div>
                    </div>
                </>
            }
            {JourneyType === 3 &&
                flightList?.map((flight: any, mainindex: any) => (
                    <div className="row flightdetail" key={mainindex}>
                        <div className="col-lg-9 col-md-8 col-sm-8 detail">
                            {flight?.segments?.map((el: any, index: any) => (
                                <Fragment>
                                    <h4 className="bound">Outbound</h4>
                                    <div className="flyDetails">
                                        <div className="placeTime">
                                            <span>{el?.[0]?.origin?.airport?.cityCode}</span>
                                            <p>{formatTo12Hour(el?.[0]?.origin?.depTime)}</p>
                                        </div>
                                        <div className="duration">
                                            <span className="stop me-1">{el?.length > 1 ? el?.length - 1 + ' Stop' : "Direct"}</span>
                                            {el?.map((ele: any, childindex: any) => (
                                                <img key={childindex} src={getAirlineLogo(ele?.airline?.airlineCode)}
                                                    onError={(e: any) => e.target.src = require("../../../../../assets/img/no-image.png")}
                                                    loading="lazy"
                                                    height="25px" width="25px"
                                                    className='rounded me-1'
                                                    title={ele?.airline?.airlineName}
                                                    alt="flights logo" />
                                            ))}
                                            <p>{convertDurationToHM(el?.map((ele: any) => ({
                                                duration: ele?.duration,
                                                depTime: ele?.origin?.depTime,
                                                arrTime: ele?.destination?.arrTime
                                            })), true)}</p>
                                        </div>
                                        <div className="placeTime">
                                            <span>{el?.[el?.length - 1]?.destination?.airport?.cityCode}</span>
                                            <p>{formatTo12Hour(el?.[el?.length - 1]?.destination?.arrTime)}</p>
                                        </div>
                                    </div>
                                    {
                                        flight?.fareOptions?.length > 0 && flight?.segments?.length - 1 === index &&
                                        <button className="toggle-btn" onClick={(e) => hendlemore(e, flight?.resultIndex)}>More Fare <i className='fa fa-angle-down'></i></button>
                                    }
                                </Fragment>
                            )
                            )}
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-4">
                            <div className="priceBox">
                                <div className="price"><span>₹ {getFarePrice(mainindex, flight, "MultiCityBoth")}</span> Per Person</div>
                                <button type="button" className="btn select" onClick={(e) => openslider(mainindex, [flight], false, "MultiCityBoth")}>Select</button>
                            </div>
                        </div>

                        <MoreFareSlider
                            mainIndex={mainindex}
                            moreFareid={moreFareid}
                            flight={flight}
                            splideClassName='multicityBoth morefare'
                            splideId={`multicityBothSlider${mainindex + 1}`}
                            ariaLabel={`Multi City Both Slider ${mainindex + 1}`}
                            flightJourneyType="MultiCityBoth"
                            getFareActiveClass={getFareActiveClass}
                            hendleSelectMoreFare={hendleSelectMoreFare}
                        />

                    </div>
                ))}
            {/* {flightList !== null ? flightList?.length === 0 && <div className='py-3 text-center text-danger'>No Records Found</div> : <></>} */}

            {/* data not found message */}
            <div className='py-3 text-center text-danger'> {noDataMessage} </div>
            {/* data not found message */}
        </div >
    )
}

export default FlightSearchList